// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_menuWrapper__a-liz {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: fit-content;
    max-width: 25px; /* IE/Edge don't support fit-content, use as a fallback */
    overflow: visible;
}

.Menu_customComponentmenuWrapper__Z49P\\+ {
    position: relative;
    display: block;
    width: fit-content;
    max-width: 20px; /* IE/Edge don't support fit-content, use as a fallback */
    overflow: visible;
}

.Menu_menuNone__QdIjr {
    display: none;
}

.Menu_menuBtn__nELvF {
    outline: none;
    color: var(--color-icon-secondary);
}
.Menu_menuBtn__nELvF:hover { color: var(--color-icon-secondary-hover); }
.Menu_menuBtn__nELvF:focus, .Menu_menuBtn__nELvF:active { color: var(--color-icon-secondary-dark); }

.Menu_inlineWrapper__chwN3 {
    display: inline-block;
    color: var(--color-icon-secondary);
}
.Menu_inlineWrapper__chwN3:hover { color: var(--color-icon-secondary-hover); }
.Menu_inlineWrapper__chwN3:focus, .Menu_menuBtn__nELvF:active { color: var(--color-icon-secondary-dark); outline: none; }

/* Makes Standard Menu dropdown on the left side */
.Menu_menuItemWrapper__X00xZ {
    position: absolute;
    min-width: 160px;
    padding: 5px 0 5px 0;
    margin: 2px 0 0;
    height: auto;
    z-index: 10;
    top: 24px;
    background-color: var(--color-109);
    border: 1px solid var(--color-108);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
.Menu_menuItemWrapper__X00xZ:not(.Menu_right__e3M8I) {
    right: 0;
}

/*  Makes Standard Menu dropdown on the right side */
.Menu_right__e3M8I.Menu_menuItemWrapper__X00xZ {
    left: 0;
}
/*  Makes Standard Menu dropdown on the top side */
.Menu_menuOpenTowardsTop__7\\+wj3 {
    bottom: 0;
}
.Menu_menuOpenTowardsTop__7\\+wj3.Menu_smallMenu__s4nYs {
    padding: 5px 0 25px 0;
}

/* Table Menu Styling */
.Menu_StandardMenuBtn__EOQ\\+M {
    color: var(--color-icon-secondary);
    margin: 4px 5px;
    outline: none;
    z-index: 2;
}

.Menu_StandardMenuBtn__EOQ\\+M:hover {
    color: var(--color-icon-secondary-hover);
}

.Menu_StandardMenuBtn__EOQ\\+M:focus,
.Menu_StandardMenuBtn__EOQ\\+M:active {
    color: var(--color-icon-secondary-dark);
}

.Menu_smallMenu__s4nYs {
    position: absolute;
    min-width: 160px;
    padding: 25px 0 5px 0;
    height: auto;
    z-index: 1;
    background-color: var(--color-109);
    border: 1px solid var(--color-108);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
.Menu_smallMenu__s4nYs:not(.Menu_right__e3M8I) {
    right: 0;
}

/*  nonButton Wrapper dropdown styling */
.Menu_customComponentMenu__V7WC- {
    position: absolute;
    min-width: 160px;
    padding: 0 0 5px 0;
    height: auto;
    z-index: 1;
    background-color: var(--color-109);
    border: 1px solid var(--color-108);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
.Menu_customComponentMenu__V7WC-:not(.Menu_right__e3M8I) {
    right: 0;
}

/*  Makes nonButton Wrapper dropdown on the right side */
.Menu_right__e3M8I.Menu_customComponentMenu__V7WC- {
    left: 0;
}

.Menu_menuOpenTowardsTop__7\\+wj3.Menu_customComponentMenu__V7WC-  {
    bottom: 30px;
}

/*  Makes TableMenu dropdown on the right side */
.Menu_right__e3M8I.Menu_smallMenu__s4nYs {
    left: 0;
}


/* MenuItem.jsx styles */
.Menu_fitText__IPgkg {
    width: auto;
    white-space: nowrap;
}
.Menu_menuItems__eNgH5 {
    font-size: 12px;
    padding: 3px 20px;
}
.Menu_menuItems__eNgH5:hover {
    cursor: pointer;
    background: var(--color-primary);
    color: var(--color-106);
}
.Menu_menuItemsSelected__ys\\+n9 {
    font-size: 12px;
    padding: 3px 20px;
    background-color: var(--color-103);
    cursor: default;
}
.Menu_menuItemsSelected__ys\\+n9:hover {
    background: var(--color-primary);
    color: var(--color-106);
}

.Menu_menuItemsDisabled__n6uP2 {
    font-size: 12px;
    padding: 3px 20px;
    color: var(--color-114);
    cursor: default;
}

.Menu_divider__J1hP1 {
    background-color: var(--color-103);
    border: none;
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
}

`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Menu/Menu.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe,EAAE,yDAAyD;IAC1E,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe,EAAE,yDAAyD;IAC1E,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;AACA,6BAAiB,wCAAwC,EAAE;AAC3D,0DAAkC,uCAAuC,EAAE;;AAE3E;IACI,qBAAqB;IACrB,kCAAkC;AACtC;AACA,mCAAuB,wCAAwC,EAAE;AACjE,gEAAwC,uCAAuC,EAAE,aAAa,EAAE;;AAEhG,kDAAkD;AAClD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kCAAkC;IAClC,kCAAkC;IAClC,qCAAqC;AACzC;AACA;IACI,QAAQ;AACZ;;AAEA,oDAAoD;AACpD;IACI,OAAO;AACX;AACA,kDAAkD;AAClD;IACI,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,kCAAkC;IAClC,qCAAqC;AACzC;AACA;IACI,QAAQ;AACZ;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,kCAAkC;IAClC,qCAAqC;AACzC;AACA;IACI,QAAQ;AACZ;;AAEA,wDAAwD;AACxD;IACI,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA,gDAAgD;AAChD;IACI,OAAO;AACX;;;AAGA,wBAAwB;AACxB;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gCAAgC;IAChC,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".menuWrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    width: fit-content;\n    max-width: 25px; /* IE/Edge don't support fit-content, use as a fallback */\n    overflow: visible;\n}\n\n.customComponentmenuWrapper {\n    position: relative;\n    display: block;\n    width: fit-content;\n    max-width: 20px; /* IE/Edge don't support fit-content, use as a fallback */\n    overflow: visible;\n}\n\n.menuNone {\n    display: none;\n}\n\n.menuBtn {\n    outline: none;\n    color: var(--color-icon-secondary);\n}\n.menuBtn:hover { color: var(--color-icon-secondary-hover); }\n.menuBtn:focus, .menuBtn:active { color: var(--color-icon-secondary-dark); }\n\n.inlineWrapper {\n    display: inline-block;\n    color: var(--color-icon-secondary);\n}\n.inlineWrapper:hover { color: var(--color-icon-secondary-hover); }\n.inlineWrapper:focus, .menuBtn:active { color: var(--color-icon-secondary-dark); outline: none; }\n\n/* Makes Standard Menu dropdown on the left side */\n.menuItemWrapper {\n    position: absolute;\n    min-width: 160px;\n    padding: 5px 0 5px 0;\n    margin: 2px 0 0;\n    height: auto;\n    z-index: 10;\n    top: 24px;\n    background-color: var(--color-109);\n    border: 1px solid var(--color-108);\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n.menuItemWrapper:not(.right) {\n    right: 0;\n}\n\n/*  Makes Standard Menu dropdown on the right side */\n.right.menuItemWrapper {\n    left: 0;\n}\n/*  Makes Standard Menu dropdown on the top side */\n.menuOpenTowardsTop {\n    bottom: 0;\n}\n.menuOpenTowardsTop.smallMenu {\n    padding: 5px 0 25px 0;\n}\n\n/* Table Menu Styling */\n.StandardMenuBtn {\n    color: var(--color-icon-secondary);\n    margin: 4px 5px;\n    outline: none;\n    z-index: 2;\n}\n\n.StandardMenuBtn:hover {\n    color: var(--color-icon-secondary-hover);\n}\n\n.StandardMenuBtn:focus,\n.StandardMenuBtn:active {\n    color: var(--color-icon-secondary-dark);\n}\n\n.smallMenu {\n    position: absolute;\n    min-width: 160px;\n    padding: 25px 0 5px 0;\n    height: auto;\n    z-index: 1;\n    background-color: var(--color-109);\n    border: 1px solid var(--color-108);\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n.smallMenu:not(.right) {\n    right: 0;\n}\n\n/*  nonButton Wrapper dropdown styling */\n.customComponentMenu {\n    position: absolute;\n    min-width: 160px;\n    padding: 0 0 5px 0;\n    height: auto;\n    z-index: 1;\n    background-color: var(--color-109);\n    border: 1px solid var(--color-108);\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n.customComponentMenu:not(.right) {\n    right: 0;\n}\n\n/*  Makes nonButton Wrapper dropdown on the right side */\n.right.customComponentMenu {\n    left: 0;\n}\n\n.menuOpenTowardsTop.customComponentMenu  {\n    bottom: 30px;\n}\n\n/*  Makes TableMenu dropdown on the right side */\n.right.smallMenu {\n    left: 0;\n}\n\n\n/* MenuItem.jsx styles */\n.fitText {\n    width: auto;\n    white-space: nowrap;\n}\n.menuItems {\n    font-size: 12px;\n    padding: 3px 20px;\n}\n.menuItems:hover {\n    cursor: pointer;\n    background: var(--color-primary);\n    color: var(--color-106);\n}\n.menuItemsSelected {\n    font-size: 12px;\n    padding: 3px 20px;\n    background-color: var(--color-103);\n    cursor: default;\n}\n.menuItemsSelected:hover {\n    background: var(--color-primary);\n    color: var(--color-106);\n}\n\n.menuItemsDisabled {\n    font-size: 12px;\n    padding: 3px 20px;\n    color: var(--color-114);\n    cursor: default;\n}\n\n.divider {\n    background-color: var(--color-103);\n    border: none;\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuWrapper": `Menu_menuWrapper__a-liz`,
	"customComponentmenuWrapper": `Menu_customComponentmenuWrapper__Z49P+`,
	"menuNone": `Menu_menuNone__QdIjr`,
	"menuBtn": `Menu_menuBtn__nELvF`,
	"inlineWrapper": `Menu_inlineWrapper__chwN3`,
	"menuItemWrapper": `Menu_menuItemWrapper__X00xZ`,
	"right": `Menu_right__e3M8I`,
	"menuOpenTowardsTop": `Menu_menuOpenTowardsTop__7+wj3`,
	"smallMenu": `Menu_smallMenu__s4nYs`,
	"StandardMenuBtn": `Menu_StandardMenuBtn__EOQ+M`,
	"customComponentMenu": `Menu_customComponentMenu__V7WC-`,
	"fitText": `Menu_fitText__IPgkg`,
	"menuItems": `Menu_menuItems__eNgH5`,
	"menuItemsSelected": `Menu_menuItemsSelected__ys+n9`,
	"menuItemsDisabled": `Menu_menuItemsDisabled__n6uP2`,
	"divider": `Menu_divider__J1hP1`
};
export default ___CSS_LOADER_EXPORT___;
